import { useCallback, useMemo } from "react";
import { useTranslation } from "../hooks";
export default function useTranslatedVoiceLanguage() {
    const { t } = useTranslation();
    const translatedByCode = useMemo(() => ({
        ar: t("voice:language.ar"),
        de: t("voice:language.de"),
        en: t("voice:language.en"),
        es: t("voice:language.es"),
        fr: t("voice:language.fr"),
        he: t("voice:language.he"),
        hi: t("voice:language.hi"),
        it: t("voice:language.it"),
        ja: t("voice:language.ja"),
        ko: t("voice:language.ko"),
        nl: t("voice:language.nl"),
        pl: t("voice:language.pl"),
        pt: t("voice:language.pt"),
        ru: t("voice:language.ru"),
        tr: t("voice:language.tr"),
        zh: t("voice:language.zh"),
        "zh-cn": t("voice:language.zh-cn"),
        "zh-hans": t("voice:language.zh-hans"),
        "zh-hant": t("voice:language.zh-hant"),
        "zh-tw": t("voice:language.zh-tw"),
    }), [t]);
    const getTranslatedVoiceLanguage = useCallback((code) => {
        if (!code)
            return "";
        return translatedByCode[code] ?? code;
    }, [translatedByCode]);
    return { getTranslatedVoiceLanguage };
}
